import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/study-group/$study-group-id/")({
  beforeLoad: ({ params }) => {
    // デフォルトでStreamにリダイレクト
    throw redirect({
      to: "/study-group/$study-group-id/stream",
      params: { "study-group-id": params["study-group-id"] },
      replace: true,
    });
  },
  component: () => <div>Redirecting to stream...</div>,
});
